<app-loading [auto]="true" />

<app-header-newgalleries  class="headerSection"
    [gallery]="gallery"
/>

<div *ngIf="!galleryId || gallery" class="globalContent">
    <app-form-newgalleries
        [creating]="creating"
        [gallery]="gallery"
        (formStatusChange)="onFormStatusChange($event)">
    </app-form-newgalleries>
    <app-footer-newgalleries
        [isFormValid]="formValid"
        (publish)="onPublish()"
        [creating]="creating"
        (back)="goBack()">
    </app-footer-newgalleries>
</div>

<app-confirm-modal
  [isOpen]="isConfirmModalVisible"
  title="{{ 'my_galleries.thanks_publishing_gallery' | translate }}"
  message="{{ 'my_galleries.thanks_publishing_gallery_text' | translate }}"
  confirmText="{{ 'my_galleries.aceptarinsp' | translate }}"
  cancelText=""
  (onConfirm)="goBack()"
  (onCancel)="goBack()"
  (onClose)="goBack()"
/>
